export type SearchKind =
  | { kind: 'empty' }
  | { kind: 'member-short'; number: string }
  | { kind: 'member-full'; prefix: string; number: string }
  | { kind: 'phone'; digits: string }
  | { kind: 'name'; q: string };

export const formatMemberId = (prefix: string, number: string): string =>
  `${prefix}-${number}`;

const compact = (input: string): string => input.replace(/[\s-]/g, '');

const MEMBER_DIGITS = 5;
const PHONE_DIGITS = 11;

export const parseSearchInput = (
  rawInput: string,
  tenantPrefix: string,
): SearchKind => {
  const trimmed = rawInput.trim();
  if (!trimmed) return { kind: 'empty' };

  const compactInput = compact(trimmed);

  if (/^\d+$/.test(compactInput)) {
    if (compactInput.length === MEMBER_DIGITS) {
      return { kind: 'member-short', number: compactInput };
    }
    if (compactInput.length === PHONE_DIGITS) {
      return { kind: 'phone', digits: compactInput };
    }
    if (compactInput.length >= 3) {
      return { kind: 'phone', digits: compactInput };
    }
    return { kind: 'name', q: trimmed };
  }

  const prefixMatch = compactInput.match(/^([A-Za-zА-Яа-я]{1,4}|\d{2})(\d+)$/);
  if (prefixMatch) {
    const prefix = prefixMatch[1]!.toUpperCase();
    const number = prefixMatch[2]!;
    if (number.length === MEMBER_DIGITS) {
      return { kind: 'member-full', prefix, number };
    }
  }

  void tenantPrefix;

  return { kind: 'name', q: trimmed };
};
